import list_icon from '@/assets/img/device/mu68/list_icon_pro.png'
import { Mu68Pro } from './mu68_pro'
import { KK } from '@/define/define'
export class Mu68Ultra extends Mu68Pro {
  name: string = 'MU68_ULTRA'
  icon: string = list_icon
  width: number = 656

  rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  fnDisableKeys: KK[] = []
  fnFactoryKeys: KK[] = [0x29, 0x1e, 0x1f, 0x20, 0x21, 0x22, 0x23, 0x24, 0x25, 0x26, 0x27, 0x2d, 0x2e, 0x30, 0x2f, 0x13, 0x33, 0x34, 0x16, 0xe3, 0x49, 0x4c, 0x4b, 0x52, 0x50, 0x51, 0x4f, 0x04, 0xe4, 0x2c]
}
